var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.4697266,37.7900391L27.8486328,6.2583008C27.0703125,4.8652344,25.5957031,4,24,4 s-3.0703125,0.8652344-3.8486328,2.2583008L2.5302734,37.7900391v0.0009766C2.1835938,38.4111328,2,39.1152344,2,39.8261719 C2,42.1279297,3.8720703,44,6.1738281,44h35.6523438C44.1279297,44,46,42.1279297,46,39.8261719 C46,39.1152344,45.8164062,38.4111328,45.4697266,37.7900391z M41.8261719,42H6.1738281C4.9755859,42,4,41.0244141,4,39.8261719 c0-0.3701172,0.0957031-0.7363281,0.2763672-1.0605469v0.0009766L21.8974609,7.2338867C22.3222656,6.4726562,23.1279297,6,24,6 s1.6777344,0.4726562,2.1025391,1.2338867L43.7236328,38.765625C43.9042969,39.0898438,44,39.4560547,44,39.8261719 C44,41.0244141,43.0244141,42,41.8261719,42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16,
    width: 2,
    height: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 35,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningMedium);
export default __webpack_public_path__ + "static/media/warning--medium.9c46476462644e4b4ccb22d4e3bf1b59.svg";
export { ForwardRef as ReactComponent };